// import SInfo from "react-native-sensitive-info";

/*
presets: [
                  [
                    require.resolve('babel-preset-react-app/dependencies'),
                    { helpers: true },
                  ],
                  '@babel/preset-env', '@babel/preset-react'
                ],
                plugins: ['@babel/plugin-proposal-class-properties'],
*/

const key = "authToken";
const nameKey = "name";
const locationKey = "location";

const storeToken = async (authToken) => {
  try {
    await localStorage.setItem(key, authToken);
  } catch (error) {
    console.log(error, "kdl");
  }
};

const getToken = async () => {
  try {
    return await localStorage.getItem(key);
  } catch (error) {}
};

const storeName = async (name) => {
  try {
    await localStorage.setItem(nameKey, name);
  } catch (error) {}
};

const getName = async () => {
  try {
    return await localStorage.getItem(nameKey);
  } catch (error) {}
};

const storeLocation = async (location) => {
  try {
    await localStorage.setItem(locationKey, location);
  } catch (error) {}
};

const getLocation = async () => {
  try {
    return await localStorage.getItem(locationKey);
  } catch (error) {}
};

const removeToken = async () => {
  try {
    return await localStorage.removeItem(key);
  } catch (error) {}
};

const removeName = async () => {
  try {
    return await localStorage.removeItem(nameKey);
  } catch (error) {}
};

const removeLocation = async () => {
  try {
    return await localStorage.removeItem(locationKey);
  } catch (error) {}
};

export default {
  storeToken,
  storeName,
  storeLocation,
  getToken,
  getName,
  getLocation,
  removeToken,
  removeName,
  removeLocation,
};
